import { useEffect, useState } from 'react'
import { getEditRequests, approveEditRequest, rejectEditRequest } from '../api'
import ProcessingOverlay from '../components/ui/ProcessingOverlay'

const fmt = (n: any) => Number(n).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',')

export default function EditRequests() {
  const [requests, setRequests] = useState<any[]>([])
  const [filter, setFilter] = useState('PENDING')
  const [expanded, setExpanded] = useState<number | null>(null)
  const [processing, setProcessing] = useState('')

  const load = () => getEditRequests(filter).then((r: any) => setRequests(r.data))
  useEffect(() => { load() }, [filter]) // eslint-disable-line

  const handleApprove = async (id: number) => {
    if (!window.confirm('Approve and apply this change?')) return
    setProcessing('Approving request...')
    try { await approveEditRequest(id); load() } finally { setProcessing('') }
  }

  const handleReject = async (id: number) => {
    if (!window.confirm('Reject this request?')) return
    setProcessing('Rejecting request...')
    try { await rejectEditRequest(id); load() } finally { setProcessing('') }
  }

  return (
    <div className="page">
      {processing && <ProcessingOverlay message={processing} />}
      <div className="page-header">
        <div>
          <div className="page-title">Edit Requests</div>
          <div className="page-subtitle">Review pending invoice change requests</div>
        </div>
        <div style={{ display: 'flex', gap: 8 }}>
          {['PENDING', 'APPROVED', 'REJECTED'].map(s => (
            <button key={s} className={`btn btn-sm ${filter === s ? 'btn-primary' : 'btn-secondary'}`}
              onClick={() => setFilter(s)}>{s}</button>
          ))}
        </div>
      </div>

      <div className="card">
        {requests.length === 0 ? (
          <div style={{ textAlign: 'center', color: '#94a3b8', padding: 32 }}>No {filter.toLowerCase()} requests</div>
        ) : (
          <table className="data-table">
            <thead>
              <tr>
                <th>Invoice</th>
                <th>Requested By</th>
                <th>Date</th>
                <th>Reason</th>
                <th>Status</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {requests.map((r: any) => (
                <>
                  <tr key={r.id} style={{ cursor: 'pointer' }} onClick={() => setExpanded(expanded === r.id ? null : r.id)}>
                    <td style={{ fontWeight: 600, color: '#2563eb' }}>{r.invoice_number}</td>
                    <td>{r.requester_name}</td>
                    <td style={{ color: '#64748b' }}>{r.created_at ? new Date(r.created_at).toLocaleDateString() : '-'}</td>
                    <td style={{ color: '#64748b' }}>{r.reason || '-'}</td>
                    <td>
                      <span className={`badge ${r.status === 'PENDING' ? 'badge-issued' : r.status === 'APPROVED' ? 'badge-paid' : 'badge-cancelled'}`}>
                        {r.status}
                      </span>
                    </td>
                    <td>
                      {r.status === 'PENDING' && (
                        <div style={{ display: 'flex', gap: 6 }}>
                          <button className="btn btn-sm btn-primary" onClick={e => { e.stopPropagation(); handleApprove(r.id) }}>Approve</button>
                          <button className="btn btn-sm btn-danger" onClick={e => { e.stopPropagation(); handleReject(r.id) }}>Reject</button>
                        </div>
                      )}
                    </td>
                  </tr>
                  {expanded === r.id && (
                    <tr key={`${r.id}-detail`}>
                      <td colSpan={6} style={{ background: '#f8fafc', padding: '12px 16px' }}>
                        <div style={{ fontWeight: 600, marginBottom: 8, fontSize: 12, color: '#475569' }}>PROPOSED CHANGES:</div>
                        <pre style={{ fontSize: 11, color: '#334155', whiteSpace: 'pre-wrap', fontFamily: 'monospace' }}>
                          {JSON.stringify(r.changes, null, 2)}
                        </pre>
                      </td>
                    </tr>
                  )}
                </>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  )
}
